import { State, Action, StateContext, Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { QueueBorrowerDecisioning, QueueDealsForDecisioning } from './decisioning.actions';
import { DecisioningService } from 'app/services/decisioning/decisioning.service';
import { SnackbarQueueService } from 'app/services/snackbar-queue/snackbar-queue.service';
import { catchError, of, tap, forkJoin, switchMap, timer, concatMap } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

export class DecisioningStateModel { }

@State<DecisioningStateModel>({
  name: 'decisioning',
  defaults: {}
})

@Injectable()
export class DecisioningState {

  constructor(
    private decisioningService: DecisioningService,
    private snackbarQueueService: SnackbarQueueService,
    private snackBar: MatSnackBar,
    private store: Store
  ) { }

  /**
   * @param ctx
   * @param borrowerId
   * @param loanProductId
   */
  @Action(QueueDealsForDecisioning)
  queueDealsForDecisioning({ }: StateContext<DecisioningStateModel>, { borrowerId, loanProducts }: QueueDealsForDecisioning) {
    const queueBorrowerDecisioning = product => this.store.dispatch(new QueueBorrowerDecisioning(borrowerId, product));
    const head = loanProducts[0];
    const tail = loanProducts.slice(1);
    return queueBorrowerDecisioning(head).pipe(
      switchMap(() => forkJoin([
        ...tail.map(product => queueBorrowerDecisioning(product))
      ])),
      catchError(() => of())
    );
  }

  @Action(QueueBorrowerDecisioning)
  queueBorrowerDecisioning({ }: StateContext<DecisioningStateModel>, { borrowerId, loanProduct }: QueueBorrowerDecisioning) {
    return this.decisioningService.queueBorrowerDecisioning(borrowerId, loanProduct.id).pipe(
      catchError((err) => {
        this.snackbarQueueService.addNotification(
          `Unsuccessfully queued ${loanProduct.lenderName}: ${loanProduct.name} for decisioning. 
            ${err.message}`,
            'lendio-alert--error'
        );
        return of();
      }),
      tap(() => {
        this.snackbarQueueService.addNotification(
          `Successfully queued ${loanProduct.lenderName}: ${loanProduct.name} for decisioning. 
            You should see an active or DNQ deal momentarily.`,
            'lendio-alert--success'
        );
      }),
      concatMap(() => timer(4500))
    );
  }
}
